const DEFAULT_ERROR_TYPES = [
    'Error',
    'EvalError',
    'RangeError',
    'ReferenceError',
    'SyntaxError',
    'TypeError',
    'URIError',
];

export default DEFAULT_ERROR_TYPES;
